import NavIcon from "./NavIcon";

export default function MemberLocationIcon(props) {
  return (
    <NavIcon {...props}>
      <g transform="translate(1 1)">
        <path d="M8 17L1 21V5L8 1M8 17L15 21M8 17V1M15 21L21 17V1L15 5M15 21V5M15 5L8 1" />
      </g>
    </NavIcon>
  );
}
